module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-2-medium-ae2695ba6a0c1cc61be944aa3b34723c.jpg";